// ====================================================
// Formatiranje cene
function formatMoney(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

// ====================================================
// VIP price renderer za pojedinačan item
function renderVipPrice(originalPrice) {
  const fm = typeof formatMoney === "function" ? formatMoney : (c => (c / 100).toFixed(2));
  const vip = window.vipDiscount;

  // ako nije VIP -> prikazujemo samo regularnu cenu
  if (!vip?.enabled) {
    return `<p class="text-sm">${fm(originalPrice)}</p>`;
  }

  const rate = vip.rate || vip.discountRate || 0;
  const discounted = Math.round(originalPrice * (1 - rate));

  return `
    <div class="flex flex-col items-end">
      <p class="text-sm">${fm(discounted)}</p>
      <p class="text-xs line-through opacity-60">${fm(originalPrice)}</p>
    </div>
  `;
}


// ====================================================
// Mini-cart main
document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.getElementById("drawer");
  if (!drawer) return;

  const list = drawer.querySelector('ul[role="list"]');
  const subtotalEl = drawer.querySelector(".js-subtotal");

  // --------------------------------------------
  // Update badge u navu
  function updateNavCartCount(count) {
    const navCart = document.querySelector(".js-nav-cart sup");

    if (count > 0) {
      if (navCart) {
        navCart.textContent = `(${count})`;
      } else {
        const parent = document.querySelector(".js-nav-cart");
        if (!parent) return;
        const sup = document.createElement("sup");
        sup.className = "w-5 h-5 !mx-0 !my-2 z-10";
        sup.textContent = `(${count})`;
        parent.appendChild(sup);
      }
    } else {
      if (navCart) navCart.remove();
    }
  }

  // --------------------------------------------
  // Render sidecart iz /cart.js
  async function updateCartDrawer() {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    updateNavCartCount(cart.item_count);

    // iskidaj postojeće stavke
    list.innerHTML = "";

    cart.items.forEach(item => {
      const price = item.original_price || item.price; // fallback
      const qty   = item.quantity;

      const li = document.createElement("li");
      li.className = "flex py-6 js-mini-cart-item";
      li.dataset.price = price;
      li.dataset.qty = qty;

      const shipping =
        item.properties && item.properties.shipping_date
          ? item.properties.shipping_date
          : "";

      li.innerHTML = `
        <div class="w-26 h-auto shrink-0 overflow-hidden">
          <a class="text-sm uppercase leading-tight" href="${item.url}">
            <img src="${item.image.replace(/(\.[^/.]+$)/, '_200x$1')}"
                 alt="${item.title}"
                 class="w-full h-auto object-cover aspect-[4/5] !mt-1">
          </a>
        </div>

        <div class="!ml-4 flex flex-1 flex-col justify-between">
          <div>
            <div class="flex justify-between text-base weidemann text-gray-900 !mb-1">
              <h3 class="leading-none">
                <a class="text-sm" href="${item.url}">${item.product_title}</a>
              </h3>
              ${renderVipPrice(price)}
            </div>

            ${item.variant_title ? `
              <p class="text-xs uppercase tracking-wider text-gray-600 !mb-3">
                ${item.variant_title}
              </p>
            ` : ""}
          </div>

          <div class="flex items-en justify-between text-sm !mb-3">
            <div class="flex gap-2 text-gray-500">
              <span>Quantity:</span>
              <div class="flex items-center" data-available="${item.inventory_quantity}">
                <button 
                  type="button"
                  class="js-qty-change w-3 h-5 flex items-center justify-center"
                  data-variant-id="${item.variant_id}"
                  data-change="-1"
                >−</button>
                <span class="min-w-[2ch] text-center js-quantity-num">${qty}</span>
                <button 
                  type="button"
                  class="js-qty-change w-3 h-5 flex items-center justify-center"
                  data-variant-id="${item.variant_id}"
                  data-change="1"
                >+</button>
              </div>
            </div>
          </div>

          ${
            shipping
              ? `<div class="flex !mb-3">
                  <p class="text-xs text-gray-500">${shipping}</p>
                </div>`
              : ""
          }

          <div class="flex">
            <button
              type="button"
              class="js-remove-item text-xs text-gray-400 hover:text-gray-500"
              data-item-id="${item.variant_id}"
            >
              Remove
            </button>
          </div>
        </div>
      `;

      list.appendChild(li);
    });

    // osnovni subtotal (za non-VIP i fallback)
    if (subtotalEl) {
      subtotalEl.style.display = "";
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    // VIP override
    updateVipSubtotal(cart);
  }

  // --------------------------------------------
  async function openSideCart() {
    await updateCartDrawer();
    drawer.showModal();
  }

  // --------------------------------------------
  // ADD TO CART
  document.querySelectorAll(".js-add-to-cart").forEach(btn => {
    btn.addEventListener("click", async e => {
      e.preventDefault();

      const originalText = btn.textContent;
      btn.textContent = "Adding...";
      btn.disabled = true;
      btn.classList.add("opacity-60", "cursor-not-allowed");

      const form = btn.closest("form");
      const formData = new FormData(form);

      try {
        await fetch("/cart/add.js", { method: "POST", body: formData });
        await openSideCart();
      } catch (error) {
        console.error("Greška pri dodavanju u korpu:", error);
      } finally {
        btn.textContent = originalText;
        btn.disabled = false;
        btn.classList.remove("opacity-60", "cursor-not-allowed");
      }
    });
  });

  // --------------------------------------------
  // Dugme iz nava (otvara sidecart)
  const navCartBtn = document.querySelector(".js-open-cart");
  if (navCartBtn) {
    navCartBtn.addEventListener("click", async e => {
      e.preventDefault();
      await openSideCart();
    });
  }

  // --------------------------------------------
  // Remove u sidecartu
  drawer.addEventListener("click", async e => {
    if (e.target.matches(".js-remove-item")) {
      const variantId = e.target.dataset.itemId;

      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: { [variantId]: 0 } })
      });

      await updateCartDrawer();

      if (window.location.pathname === "/cart") {
        window.location.reload();
      }
    }
  });

  // --------------------------------------------
  // Promena količine (+/-)
  drawer.addEventListener("click", async e => {
    if (!e.target.matches(".js-qty-change")) return;

    const btn = e.target;
    const variantId = btn.dataset.variantId;
    const change = parseInt(btn.dataset.change, 10);

    const qtySpan = btn.parentElement.querySelector(".js-quantity-num");
    const currentQty = parseInt(qtySpan.textContent, 10);
    const newQty = Math.max(currentQty + change, 0);

    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: { [variantId]: newQty } })
    });

    await updateCartDrawer();

    if (window.location.pathname === "/cart") {
      window.location.reload();
    }
  });

  // --------------------------------------------
  // Kad se drawer otvori nekim drugim putem (Tailwind dialog event)
  drawer.addEventListener("dialog:open", updateCartDrawer);
});


// ====================================================
// VIP SUBTOTAL – radi sa TVOJOM HTML STRUKTUROM
function updateVipSubtotal(cart) {
  const vip = window.vipDiscount;
  const rate = vip?.rate || vip?.discountRate || 0;

  // ako user NIJE VIP ili nemamo rate → samo ostavi regular subtotal
  if (!vip?.enabled || !rate) {
    const reg = document.querySelector(".js-subtotal");
    if (reg && cart) {
      reg.style.display = "";
      reg.textContent = formatMoney(cart.total_price);
    }
    return;
  }

  let origTotal = 0;
  let newTotal  = 0;

  cart.items.forEach(item => {
    const price = item.original_price || item.price;
    const qty   = item.quantity;

    const discounted = Math.round(price * (1 - rate));

    origTotal += price * qty;
    newTotal  += discounted * qty;
  });

  // sakrij standardni subtotal
  const reg = document.querySelector(".js-subtotal");
  if (reg) {
    reg.style.display = "none";
  }

  // upiši VIP novu cenu
  const vipNew = document.querySelector(".js-mini-cart-total");
  if (vipNew) {
    vipNew.textContent = formatMoney(newTotal);
  }

  // upiši staru cenu (line-through)
  const vipOld = document.querySelector(".js-mini-cart-old-total");
  if (vipOld) {
    vipOld.textContent = formatMoney(origTotal);
  }
}


// ====================================================
// Checkout auto-discount (ako ga još uvek želiš ovako)
document.addEventListener("click", e => {
  const btn = e.target.closest(".js-checkout");
  if (!btn) return;

  e.preventDefault();

  const url = window.vipDiscount?.enabled
    ? "/checkout?discount=10ONTHEHOUSE"
    : "/checkout";

  window.location.href = url;
});
